// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"bf010934","121":"d5268fdf","163":"04ba4ebf","251":"1a4ffae7","398":"10ae421d","444":"015ad043","460":"5f2a848f","606":"d6fd0ed6","693":"98ccb391","767":"0ee81292","916":"8cd08e21"}[chunkId] + ".chunk.js";
};